module.exports = __webpack_public_path__ + "img/list1.d53ce989.png";